export default __webpack_public_path__ + "static/Inter-Regular-cd46dd3ec2566f5f0439aefb745ed3ed.woff2";